module.exports = __webpack_public_path__ + "img/popup_error.c44dcb06.svg";